<template>
  <div>
    <div v-if="isRouterAlive">
      <Slider :banner="$t('sliderimg')">
        <div class="row align-items-center">
          <div class="col fontsiyuanmedium">
            <div class="slider-title fontsiyuanmedium">
              {{ $t("slidertitle") }}
            </div>
            <div class="slider-subtitle fontsiyuanregular">
              {{ $t("slidersubtitle") }}
            </div>
          </div>
        </div>
      </Slider>
      <div>
        <div
          class="
          news-title-wide news-title-group
          row
          justify-content-center
          sticky2
        "
          style="text-align: center"
        >
          <div
            :class="
              `col-lg-1 col-md-2 col-sm-3 col-6 news-title ${
                active == 0 ? 'active' : ''
              }`
            "
            @click="change(0)"
          >
            <span> {{ JSON.parse($t("abouttitlelist"))[0] }}</span>
          </div>
          <div
            @click="change(1)"
            :class="
              `col-lg-1 col-md-2 col-sm-3 col-6 news-title ${
                active == 1 ? 'active' : ''
              }`
            "
          >
            <span> {{ JSON.parse($t("abouttitlelist"))[1] }}</span>
          </div>
          <div
            @click="change(2)"
            :class="
              `col-lg-1 col-md-2 col-sm-3 col-6 news-title ${
                active == 2 ? 'active' : ''
              }`
            "
          >
            <span> {{ JSON.parse($t("abouttitlelist"))[2] }}</span>
          </div>
          <div
            @click="change(3)"
            :class="
              `col-lg-1 col-md-2 col-sm-3 col-6 news-title ${
                active == 3 ? 'active' : ''
              }`
            "
          >
            <span> {{ JSON.parse($t("abouttitlelist"))[3] }}</span>
          </div>
          <div
            @click="change(4)"
            :class="
              `col-lg-1 col-md-2 col-sm-3 col-6 news-title ${
                active == 4 ? 'active' : ''
              }`
            "
          >
            <span> {{ JSON.parse($t("abouttitlelist"))[4] }}</span>
          </div>
          <div
            @click="change(5)"
            :class="
              `col-lg-1 col-md-2 col-sm-3 col-6 news-title ${
                active == 5 ? 'active' : ''
              }`
            "
          >
            <span> {{ JSON.parse($t("abouttitlelist"))[5] }}</span>
          </div>
          <div
            @click="change(6)"
            :class="
              `col-lg-1 col-md-2 col-sm-3 col-6 news-title ${
                active == 6 ? 'active' : ''
              }`
            "
          >
            <span> {{ JSON.parse($t("abouttitlelist"))[6] }}</span>
          </div>
          <div
            @click="change(7)"
            :class="
              `col-lg-1 col-md-2 col-sm-3 col-6 news-title ${
                active == 7 ? 'active' : ''
              }`
            "
          >
            <span> {{ JSON.parse($t("abouttitlelist"))[7] }}</span>
          </div>
          <div
            @click="change(8)"
            :class="
              `col-lg-1 col-md-2 col-sm-3 col-6 news-title ${
                active == 8 ? 'active' : ''
              }`
            "
          >
            <span> {{ JSON.parse($t("abouttitlelist"))[8] }}</span>
          </div>
        </div>

        <div class="news-title-thin">
          <b-container>
            <div class="news-title-header" @click="visible1 = !visible1">
              <span class="news-title-title">{{
                JSON.parse($t("abouttitlelist"))[active]
              }}</span>
              <span class="news-title-button"
                ><b-img v-if="!visible1" :src="colarrowdown"></b-img
                ><b-img v-if="visible1" :src="colarrowup"></b-img
              ></span>
            </div>
            <b-collapse
              v-model="visible1"
              class="thin-item-body"
              style="z-index: 1703"
            >
            <div 
                v-for="(item, index) in JSON.parse($t('abouttitlelist'))"
                v-bind:key="index">
              <div
                class="news-title-header"
                v-if="active!=index"
              >
                <span class="news-title-title" @click="change(index)">{{
                  item
                }}</span>
              </div>
            </div>
            </b-collapse>
          </b-container>
        </div>
      </div>
    </div>

    <div>
      <About1
        v-if="active == 0 || active == 1"
        :active="parseInt($route.query.sort)"
      ></About1>
      <About2 v-if="active == 2" :active="parseInt($route.query.sort)"></About2>
      <About3
        v-if="active == 3 || active == 4"
        :active="parseInt($route.query.sort)"
      ></About3>
      <About4 v-if="active == 5" :active="parseInt($route.query.sort)"></About4>
      <About5
        v-if="active == 6 || active == 7 || active == 8"
        :active="parseInt($route.query.sort)"
      ></About5>
    </div>

    <Footer class="w-100" />
  </div>
</template>

<script>
import Slider from "../components/slider2";
import Footer from "../components/footer";
import About1 from "./about1.vue";
import About2 from "./about2.vue";
import About3 from "./about3.vue";
import About4 from "./about4.vue";
import About5 from "./about5.vue";
import Sticky from "sticky-js";
export default {
  components: {
    Slider,
    Footer,
    About1,
    About2,
    About3,
    About4,
    About5,
  },
  data() {
    return {
      isRouterAlive: true,

      active: 0,

      visible1: false,
    };
  },
  watch: {
    // page(to) {
    //   this.page = to;
    //   this.getNewsDetail();
    // },
    $route(to, from) {
      //监听路由是否变化
      if (to.query.sort != from.query.sort) {
        this.active = parseInt(to.query.sort) || 0;
        this.$i18n.locale = localStorage.getItem("lang") || "zh";
        this.getAboutPage();
      }
    },
  },
  computed: {
    colarrowdown() {
      return this.$store.state.colarrowdown;
    },
    colarrowup() {
      return this.$store.state.colarrowup;
    },
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    },
    getAboutPage() {
      const _this = this;
      this.$store.dispatch("getAboutPage").then(({ zh, en }) => {
        _this.$i18n.mergeLocaleMessage("en", en);
        _this.$i18n.mergeLocaleMessage("zh", zh);
        let lang = _this.$i18n.locale;
        _this.$i18n.locale = lang;
        _this.reload();
        const sticky = new Sticky(".sticky");
        sticky.update();
        const sticky2 = new Sticky(".sticky2");
        sticky2.update();
      });
    },
    change(index) {
      this.active = index;
      if (index != parseInt(this.$route.query.sort)) {
        this.$router.push("/about?sort=" + index);
      }
      this.visible1=false
      // console.log(index)
      // console.log(this.$route.query.sort)
      // console.log(this.active)
      // switch (parseInt(index)) {
      //   case 0:
      //     this.$router.push("/about?sort=0");
      //     break;
      //   case 1:
      //     this.$router.push("/about?sort=1");
      //     break;
      //   case 2:
      //     this.$router.push("/about?sort=2");
      //     break;
      //   case 3:
      //     this.click3 = true;
      //     if(this.active!=index){
      //     this.$router.push("/about?sort=3");
      //     }
      //     this.click3 = false;
      //     break;
      //   case 4:
      //     this.click3 = true;
      //     if(this.active!=index){
      //     this.$router.push("/about?sort=4");
      //     }
      //     this.click3 = false;
      //     break;
      //   case 5:
      //     this.$router.push("/production?sort=5");
      //     break;
      //   case 6:
      //     this.$router.push("/aboutteam?sort=6");
      //     break;
      //   case 7:
      //     this.$router.push("/aboutteam?sort=7");
      //     break;
      //   case 8:
      //     this.$router.push("/aboutteam?sort=8");
      //     break;
      // }
    },

    handleAbout2Scrollx2() {
      //   console.log("滚动高度2", window.pageYOffset);
      //   console.log("距离顶部高度22", this.$refs.about2page.$el.offsetTop);
      //   console.log("距离顶部高度2", this.$refs.about2page.$el.clientHeight);
    },
  },
  updated() {},
  mounted() {
    this.active = parseInt(this.$route.query.sort);
    console.log(this.active == 6);
    // this.reloadview();

    // 滚动条的获取
    window.addEventListener("scroll", this.handleAbout2Scrollx2, true);
  },
  created() {
    this.getAboutPage();
  },
};
</script>
<style>
.slider-title {
  margin-left: 115px;
  color: #fff;
  font-size: 42px;
  font-weight: bold;
}
.slider-subtitle {
  margin-left: 115px;
  color: #fff;
  font-size: 20px;
  font-weight: 100;
}
.news-title-group {
  z-index: 1777;
  background-color: #fff;
  border-bottom: 0.5px #bdbdbd88 solid;
  height: 75px;
}
.news-title {
  background-color: #fff;
  padding: 25px 0;
  cursor: pointer;
}
.news-title span {
  padding: 27px 0;
  height: 75px;
}
.news-title span:hover {
  color: #c00f31;
  font-weight: 800;
  border-bottom: 3px solid #c00f31;
}
.news-title.active span {
  border-bottom: 3px solid #c00f31;
}
.news-title.active {
  color: #c00f31;
  font-weight: 800;
}
.news-list {
  padding-bottom: 100px;
}
.page-item.active .page-link {
  color: #c00f31;
  background-color: #ffffff00;
}
.page-link {
  color: #000;
  border: 0;
}
.page-link:hover {
  color: #c00f31;
}
.pagestyle {
  color: #000;
  padding: 6px 10px;
  border: 0.5px #bdbdbd88 solid;
}
.pagestyle:hover {
  background-color: #00000000;
  color: #c00f31;
}
.page-item:hover {
  background-color: #00000000;
}
.news-pagination {
  margin-top: 100px;
}
.news-item {
  margin-top: 50px;
  cursor: pointer;
}

.news-item:hover {
  -webkit-box-shadow: #00000034 0px 0px 10px;
  -moz-box-shadow: #00000034 0px 0px 10px;
  box-shadow: #00000034 0px 0px 10px;
}
.news-body {
  padding: 10px 30px 20px 30px;
  background-color: #ededed;
}
.product-item-body-head {
  font-size: 12px;
}
.product-item-date {
  font-size: 12px;
  font-weight: 200;
  color: #8a8a8a;
  margin-left: 10px;
}
.product-item-type {
  background-color: #c00f31;
  color: #ffffff;
  padding: 0 5px;
  margin-left: 15px;
}
.news-item-title {
  font-weight: bold;
  font-size: 16px;
  color: #000;
}
.news-item-info {
  margin-top: 30px;
  font-size: 12px;
  color: #8a8a8a;
}
@media only screen and (max-width: 500px) {
  .slider-title {
    margin-left: 65px;
    color: #fff;
    font-size: 30px;
    font-weight: bold;
  }
  .slider-subtitle {
    margin-left: 65px;
    color: #fff;
    font-size: 10px;
    font-weight: 100;
  }
}
.about-content-1 {
  margin-top: 50px;
  margin-bottom: 50px;
}
.about-title {
  font-size: 25px;
  font-weight: bold;
  border-bottom: 2px #c00f31 solid;
  margin-bottom: 50px;
  white-space: nowrap;
}
.about-content-info {
  color: #666666;
  font-weight: 400;
  font-size: 12px;
}

.about-content-info div {
  margin-top: 20px;
}
.about-content-2 {
  min-height: 260px;
  background: url(https://wxapp-1304693027.cos.ap-shanghai.myqcloud.com/test/about/about-bg-01.jpg)
    no-repeat top center scroll;
  background-size: cover;
  text-align: center;
  padding-top: 20px;
  padding-bottom: 20px;
}

.about-content-2 img {
  height: 110px;
  margin-top: 40px;
}
.about-img-content {
  background-color: #fff;
  min-height: 220px;
}
.info-title {
  color: #000;
  font-size: 15px;
  font-weight: bold;
}
.b-bg {
  background-color: #ededed;
  text-align: center;
  padding: 50px 0;
  margin-bottom: 30px;
}

.b-bg .slogn {
  font-weight: bold;
}
.b-bg .info {
  font-weight: 200;
}

.news-title-thin {
  display: none;
}
@media only screen and (max-width: 1000px) {
  .news-title-wide {
    display: none;
  }
  .news-title-thin {
    display: block;
  }
}
@media only screen and (max-width: 500px) {
  .news-title-wide {
    display: none;
  }
  .news-title-thin {
    display: block;
  }
  .news-title-button img {
    width: 15px;
    position: absolute;
    right: 30px;
  }
  .news-title-header {
    font-size: 15px;
    font-weight: bold;
    padding: 10px 0;
    border-bottom: 1px #bdbdbd44 solid;
  }
}
</style>
